<template>
  <page class="home-page">
    <div class="home-warp">
      <img class="home-logo" src="../assets/imgs/logo.png" alt="" />
      <h2 class="home-title">RENT A POWER BANK</h2>
      <p class="home-title-des">Stay charged, Stay Connected!</p>
      <div class="login-btn">
        <div
          v-if="token && user"
          @click="isMenuView = true"
          class="btn googleloginbtn2 user-login"
        >
          <span>{{ user.pname }}</span>
        </div>
        <template v-else>
          <login-google @success="loadUser">
            <div class="btn googleloginbtn2">
              <img src="../assets/imgs/icon_google.png" alt="" />
              <span>Sign in with Google</span>
              <div id="buttonDiv" class="google-login"></div>
            </div>
          </login-google>
          <login-apple v-if="system === 'ios'" @success="loadUser()">
            <button class="btn appleloginbtn2" id="sign-in-with-apple-button">
              <img src="../assets/imgs/icon_apple.png" alt="" />
              <span>Sign in with Apple</span>
            </button>
          </login-apple>
        </template>
      </div>
      <div class="warp-cont" v-if="cabinet">
        <div class="warp-cont-row">
          <img src="../assets/imgs/checkbox_selected2.png" alt="" />
          {{ descFormat("{currencyName}{jifei} per {jifeiDanwei} minutes") }}
        </div>
        <div class="warp-cont-row">
          <img src="../assets/imgs/checkbox_selected2.png" alt="" />
          {{ descFormat("Daily cap: {currencyName}{fengding}") }}
        </div>
        <div class="warp-cont-row">
          <img src="../assets/imgs/checkbox_selected2.png" alt="" />
          {{ descFormat("Refundable deposit: {currencyName}{yajin}") }}
        </div>
      </div>
      <div class="home-warp-borrow">
        <label class="agree" v-if="cabinet">
          <input
            class="checkbox"
            type="checkbox"
            v-model="agree_is_checked"
            @change="agreeHandleChange"
          />
          {{
            descFormat(
              "I agree to the rental terms and authorise a refundable {currencyName}{yajin} deposit hold"
            )
          }}
        </label>
        <div class="btn borrow" @click="onSubmit()">Agree & Rent</div>
      </div>
      <div class="home-warp-readme">
        <span @click="onReadMe">Terms of Use</span>
        <span class="readme">Privacy and Cookies</span>
      </div>
    </div>

    <popup-warp v-model="isCreditcard">
      <div>
        <div class="creditcard-input">
          <div id="credit-card-element"></div>
        </div>
        <div class="btn creditcard-btn" @click="onStripeSetup">
          {{ $t("confirm").paynow }}
        </div>
      </div>
    </popup-warp>

    <popup-warp v-model="isMenuView" dialogTransition="slide-left">
      <menu-side @close="isMenuView = false"></menu-side>
    </popup-warp>
  </page>
</template>

<script>
import { mapState } from "vuex";
import { QR_CODE, ZH_CODE } from "../apis/cabinet";
import { USER_INFO } from "../apis/user";
import { LoginGoogle, LoginApple } from "../components/login";

import { MenuSide } from "../components/menu";
import { PopupWarp } from "../components/popup";

import homeMixin from "../mixins/home";
import paymentMixin from "../mixins/payment";
import stripeMixin from "../mixins/stripe";
export default {
  mixins: [homeMixin, paymentMixin, stripeMixin],
  components: {
    LoginGoogle,
    LoginApple,
    MenuSide,
    PopupWarp
  },
  computed: {
    ...mapState([
      "qrcode",
      "zhcode",
      "cabinet",
      "browser",
      "token",
      "user",
      "system"
    ]),
    i18n() {
      return this.$t("home");
    },
    i18nMsg() {
      return this.$t("msg");
    },
    title() {
      return process.env.VUE_APP_NAME;
    },
    code() {
      return this.qrcode || this.zhcode;
    },
    scanUrl() {
      if (this.qrcode) {
        return `${QR_CODE}?id=${this.qrcode}&usePriceUnit=true`;
      }
      if (this.zhcode) {
        return `${ZH_CODE}/${this.zhcode}`;
      }
      return "";
    },
    banner() {
      return this.cabinet && this.cabinet.shoplogo
        ? `background-image: url(${this.cabinet.shoplogo});`
        : "";
    },
    amount() {
      if (this.cabinet) {
        return (this.cabinet.yajin - this.cabinet.myyue).toFixed(2);
      } else {
        return 0;
      }
    },
    priceStrategy() {
      return this.cabinet.priceStrategy || {};
    }
  },
  data() {
    return {
      isMenuView: false,
      agree_is_checked: true
    };
  },
  methods: {
    descFormat(text) {
      return `${text}`.format(this.cabinet);
    },
    onScan() {
      if (!this.scanUrl) return;
      this.$loading(true);
      this.$post(
        this.scanUrl,
        {},
        resp => {
          this.$loading(false);
          this.$store.commit("cabinet", {
            qrcode: this.code,
            ...resp
          });
          if (resp.zujieNum && resp.zujieNum > 0) {
            this.$confirm({
              title: this.i18n.msg_fail_title,
              content: `${this.i18n.msg_rentcount}`.format(resp),
              confirmText: this.i18nMsg.vieworder,
              cancelText: this.i18nMsg.cancel
            })
              .then(() => {
                this.$router.push("/order");
                this.$store.commit("qrcode", "");
              })
              .catch(() => {
                this.$store.commit("qrcode", "");
              });
          } else {
            this.isScan = true;
            this.isBtns = false;
            this.adVisible = true;
          }
        },
        error => {
          this.$loading(false);
          this.$toast(error);
        }
      );
      if (this.user) this.getPayMode();
    },
    loadUser() {
      this.$get(
        USER_INFO,
        {},
        resp => {
          if (resp.user) {
            this.$store.commit("user", resp.user);
            this.onScan();
          } else {
            this.$store.commit("user", null);
          }
        },
        error => {
          this.$store.commit("user", null);
          console.log(error);
        }
      );
    },
    onCode() {
      this.isBtns = false;
      this.loadUser();
    }
  },
  created() {
    const { qrcode, zhcode, paymentId, pmid } = this.$route.query;
    let _qrcode = qrcode || zhcode;
    if (_qrcode) this.onScan(_qrcode);

    const payId = new URLSearchParams(window.location.search).get(
      "payment_intent"
    );
    if (paymentId && pmid) {
      this.onConfirmSaveCard(paymentId, pmid);
    } else if (payId) {
      this.confirmSetup(payId);
      return;
    }
    if (this.token && !this.user) this.loadUser();
  }
};
</script>

<style lang="less">
.home-page {
  height: 100vh;
  overflow: hidden;
  background-color: #fafe45;
}

.home-warp {
  height: 100vh;
  overflow-x: auto;
  .home-logo {
    display: block;
    width: 320px;
    margin: 109px auto 35px;
  }
  .home-title {
    font-size: 50px;
    text-align: center;
    &-des {
      font-size: 28px;
      font-weight: bold;
      text-align: center;
    }
  }

  &-borrow {
    margin: 60px 80px 0;
    .agree {
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 0 30px 0 60px;
      font-size: 24px;
      color: #000;
    }
    .checkbox {
      transform: scale(1.5);
      margin-right: 20px;
    }
    .borrow {
      height: 123px;
      line-height: 123px;
      border-radius: 66px;
      margin: 40px 0 60px;
      color: #000;
      font-size: 46px;
      font-weight: bold;
      background-color: #fff;
    }
  }

  &-readme {
    display: block;
    color: #000;
    font-size: 24px;
    text-align: center;
    text-decoration: underline;
    .readme {
      margin-left: 20px;
    }
  }
}

.warp-cont {
  margin: 80px 0 0 100px;
  &-row {
    display: flex;
    font-size: 28px;
    line-height: 32px;
    justify-content: flex-start;
    align-items: center;
    padding: 12px 0;
    color: #000;
    font-weight: bold;

    img {
      width: 42px;
      height: 42px;
      margin-right: 18px;
    }
  }
}

.login-btn {
  margin: 76px 86px 0;
  .appleloginbtn2 {
    width: 100%;
    height: 123px;
    line-height: 123px;
    border-radius: 66px;
    border: none;
    margin: 40px 0 0;
    padding-left: 24px;
    justify-content: flex-start;
    color: #fff;
    font-weight: bold;
    font-size: 36px;
    background-color: #000;
    img {
      width: 136px;
    }
  }
  .user-login {
  }
  .googleloginbtn2 {
    position: relative;
    height: 123px;
    line-height: 123px;
    border-radius: 66px;
    border: none;
    margin: 40px 0 0;
    padding-left: 24px;
    justify-content: flex-start;
    overflow: hidden;
    color: #000;
    font-weight: bold;
    font-size: 36px;
    background-color: #fff;
    img {
      width: 136px;
    }
    .google-login {
      position: absolute;
      top: 24px;
      left: 0;
      bottom: 0;
      opacity: 0;
    }
  }

  .user-login {
    justify-content: center;
  }
}

.creditcard-input {
  margin: 48px 48px 80px;
  padding: 20px;
  border-radius: 20px;
  border: 1px solid #e4e7ed;
}

.creditcard-btn {
  margin: 48px;
  background: #000;
  color: #fff;
}
</style>
